export default {
  meta: {
    title: '客流门店分析',
  },
};
